export class Vector2 {
  x: number;
  y: number;

  constructor(x = 0, y = 0) {
    this.x = x;
    this.y = y;
  }

  static randomAngle() {
    return Vector2.angle(Math.random() * Math.PI * 2);
  }
  static angle(rad: number) {
    return new Vector2(Math.cos(rad), Math.sin(rad));
  }
  static from({ x, y }: { x: number; y: number }) {
    return new Vector2(x, y);
  }

  angle() {
    const magnitude = this.magnitude();
    if (magnitude === 0) return 0;
    return Math.acos(this.x / magnitude);
  }
  magnitude() {
    return Math.sqrt(this.x ** 2 + this.y ** 2);
  }
  distance(other: { x: number; y: number }) {
    return this.sub(other).magnitude();
  }
  unit() {
    return this.div(this.magnitude());
  }

  add({ x, y }: { x: number; y: number }) {
    return new Vector2(this.x + x, this.y + y);
  }
  sub({ x, y }: { x: number; y: number }) {
    return new Vector2(this.x - x, this.y - y);
  }
  mul(obj: { x: number; y: number } | number) {
    if (typeof obj === "object")
      return new Vector2(this.x * obj.x, this.y * obj.y);
    else return new Vector2(this.x * obj, this.y * obj);
  }
  div(obj: { x: number; y: number } | number) {
    if (typeof obj === "object")
      return new Vector2(this.x / obj.x, this.y / obj.y);
    else if (obj === 0) return new Vector2();
    else return new Vector2(this.x / obj, this.y / obj);
  }
}
